<template>
  <div>
    <!-- <div class="profile-drop-wrap"> -->
    <!-- <div class="head" v-if="userLogoDet.logoDet">
        <div class="profile">
          <img
            src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/gettyimages-168889366-1572948662.jpg?crop=0.668xw:1.00xh;0.105xw,0&resize=480:*"
            alt
          />
        </div>
        <div class="details">
          <div class="name">{{getUserName}}</div>
          <div  v-if="userLogoDet.logoDet.roles && userLogoDet.logoDet.roles.length>0">
            <div  class="role" v-for="(role,index) in userLogoDet.logoDet.roles" :key="'r'+index">
            <div >{{role}}</div>
            </div>
    </div>-->
    <!--              <div class="ag-name">-->
    <!--                H24 Agency UK-->
    <!--              </div>-->
    <!-- <div class="email" v-if="userLogoDet.logoDet.agencyname">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Capa_1"
              enable-background="new 0 0 512 512"
              height="512"
              viewBox="0 0 512 512"
              width="512"
            >
              <path
                d="m328.302 0h-144.602c-23.023 0-42.787 14.183-51.041 34.267h246.686c-8.254-20.084-28.02-34.267-51.043-34.267z"
              />
              <path
                d="m392.567 64.267h-273.132c-30.42 0-55.168 24.748-55.168 55.167v377.566c0 8.284 6.717 15 15 15h97.467v-71.233c0-30.419 24.748-55.167 55.168-55.167h48.199c30.42 0 55.166 24.748 55.166 55.167v71.233h97.467c8.285 0 15-6.716 15-15v-377.566c-.001-30.419-24.747-55.167-55.167-55.167zm-222.359 282.673c-2.789 2.79-6.658 4.391-10.609 4.391-3.939 0-7.811-1.601-10.6-4.391-2.801-2.79-4.4-6.66-4.4-10.609 0-3.941 1.6-7.811 4.4-10.601 2.789-2.79 6.65-4.399 10.6-4.399 3.951 0 7.82 1.609 10.609 4.399 2.791 2.79 4.391 6.65 4.391 10.601 0 3.948-1.6 7.818-4.391 10.609zm0-64.27c-2.789 2.8-6.658 4.399-10.609 4.399-3.939 0-7.811-1.6-10.6-4.399-2.801-2.79-4.4-6.66-4.4-10.601 0-3.949 1.6-7.819 4.4-10.609 2.789-2.79 6.65-4.391 10.6-4.391 3.951 0 7.82 1.601 10.609 4.391 2.791 2.79 4.391 6.66 4.391 10.609 0 3.941-1.6 7.811-4.391 10.601zm0-64.261c-2.799 2.79-6.658 4.391-10.609 4.391-3.939 0-7.811-1.601-10.6-4.391-2.801-2.789-4.4-6.659-4.4-10.609s1.6-7.82 4.4-10.61c2.789-2.79 6.66-4.39 10.6-4.39 3.951 0 7.811 1.6 10.609 4.39 2.791 2.79 4.391 6.66 4.391 10.61s-1.6 7.82-4.391 10.609zm0-64.269c-2.789 2.79-6.658 4.39-10.609 4.39-3.939 0-7.811-1.6-10.609-4.39-2.791-2.79-4.391-6.66-4.391-10.61 0-3.949 1.6-7.81 4.391-10.6 2.799-2.8 6.66-4.4 10.609-4.4 3.951 0 7.82 1.601 10.609 4.4 2.791 2.79 4.391 6.65 4.391 10.6s-1.6 7.82-4.391 10.61zm64.262 192.8c-2.791 2.79-6.66 4.391-10.602 4.391-3.949 0-7.818-1.601-10.609-4.391-2.789-2.79-4.391-6.66-4.391-10.609 0-3.95 1.602-7.811 4.391-10.601 2.791-2.79 6.66-4.399 10.609-4.399 3.951 0 7.811 1.609 10.602 4.399 2.799 2.79 4.398 6.65 4.398 10.601 0 3.948-1.599 7.818-4.398 10.609zm.01-64.27c-2.801 2.8-6.66 4.399-10.611 4.399-3.949 0-7.809-1.6-10.609-4.399-2.789-2.79-4.391-6.66-4.391-10.601 0-3.949 1.602-7.819 4.391-10.609 2.801-2.79 6.66-4.391 10.609-4.391 3.951 0 7.811 1.601 10.611 4.391 2.789 2.79 4.389 6.66 4.389 10.609-.001 3.951-1.6 7.811-4.389 10.601zm0-64.261c-2.801 2.79-6.66 4.391-10.611 4.391-3.949 0-7.809-1.601-10.609-4.391-2.789-2.789-4.391-6.659-4.391-10.609s1.602-7.82 4.391-10.61c2.801-2.79 6.66-4.39 10.609-4.39 3.941 0 7.811 1.6 10.611 4.39 2.789 2.79 4.389 6.66 4.389 10.61-.001 3.95-1.6 7.82-4.389 10.609zm0-64.269c-2.801 2.79-6.66 4.39-10.611 4.39-3.949 0-7.818-1.6-10.609-4.39-2.789-2.79-4.391-6.66-4.391-10.61 0-3.949 1.602-7.81 4.391-10.6 2.791-2.8 6.66-4.4 10.609-4.4 3.951 0 7.82 1.601 10.611 4.4 2.789 2.79 4.389 6.66 4.389 10.6-.001 3.95-1.6 7.81-4.389 10.61zm64.259 192.8c-2.791 2.79-6.66 4.391-10.611 4.391-3.939 0-7.809-1.601-10.6-4.391-2.789-2.79-4.389-6.66-4.389-10.609 0-3.95 1.6-7.811 4.389-10.601 2.791-2.79 6.66-4.399 10.6-4.399 3.951 0 7.82 1.609 10.611 4.399 2.799 2.79 4.4 6.66 4.4 10.601.001 3.948-1.601 7.818-4.4 10.609zm0-64.27c-2.791 2.8-6.66 4.399-10.611 4.399-3.939 0-7.809-1.6-10.6-4.399-2.789-2.79-4.389-6.66-4.389-10.601 0-3.949 1.6-7.819 4.389-10.609 2.791-2.79 6.66-4.391 10.6-4.391 3.951 0 7.82 1.601 10.611 4.391 2.799 2.79 4.4 6.66 4.4 10.609.001 3.941-1.601 7.811-4.4 10.601zm-25.599-74.87c0-3.95 1.6-7.82 4.389-10.61 2.791-2.79 6.66-4.39 10.611-4.39 3.939 0 7.809 1.6 10.6 4.39 2.789 2.79 4.389 6.66 4.389 10.61s-1.6 7.82-4.389 10.609c-2.791 2.79-6.66 4.391-10.6 4.391-3.951 0-7.82-1.601-10.611-4.391-2.79-2.789-4.389-6.659-4.389-10.609zm25.599-53.66c-2.791 2.79-6.65 4.39-10.6 4.39-3.951 0-7.82-1.6-10.611-4.39-2.789-2.79-4.389-6.66-4.389-10.61 0-3.949 1.6-7.81 4.389-10.6 2.791-2.8 6.66-4.4 10.611-4.4 3.949 0 7.809 1.601 10.6 4.4 2.789 2.79 4.4 6.65 4.4 10.6.001 3.95-1.611 7.82-4.4 10.61zm64.27 192.8c-2.789 2.79-6.66 4.391-10.609 4.391-3.941 0-7.811-1.601-10.6-4.391-2.801-2.79-4.4-6.66-4.4-10.609 0-3.941 1.6-7.811 4.4-10.601 2.789-2.79 6.648-4.399 10.6-4.399 3.949 0 7.82 1.609 10.609 4.399 2.791 2.79 4.391 6.65 4.391 10.601-.001 3.948-1.6 7.818-4.391 10.609zm0-64.27c-2.789 2.8-6.66 4.399-10.609 4.399-3.951 0-7.811-1.6-10.6-4.399-2.801-2.79-4.4-6.66-4.4-10.601 0-3.949 1.6-7.819 4.4-10.609 2.789-2.79 6.648-4.391 10.6-4.391 3.949 0 7.82 1.601 10.609 4.391 2.791 2.79 4.391 6.66 4.391 10.609-.001 3.941-1.6 7.811-4.391 10.601zm0-64.261c-2.801 2.79-6.66 4.391-10.609 4.391-3.941 0-7.811-1.601-10.6-4.391-2.801-2.789-4.4-6.659-4.4-10.609s1.6-7.82 4.4-10.61c2.789-2.79 6.658-4.39 10.6-4.39 3.949 0 7.809 1.6 10.609 4.39 2.791 2.79 4.391 6.66 4.391 10.61-.001 3.95-1.6 7.82-4.391 10.609zm0-64.269c-2.801 2.79-6.66 4.39-10.609 4.39-3.951 0-7.811-1.6-10.6-4.39-2.801-2.79-4.4-6.66-4.4-10.61 0-3.949 1.6-7.81 4.4-10.6 2.789-2.8 6.648-4.4 10.6-4.4 3.949 0 7.82 1.601 10.609 4.4 2.791 2.79 4.391 6.65 4.391 10.6-.001 3.95-1.6 7.82-4.391 10.61z"
              />
              <path
                d="m280.101 415.6h-9.1v96.4h34.266v-71.233c0-13.877-11.289-25.167-25.166-25.167z"
              />
              <path
                d="m206.733 440.767v71.233h34.268v-96.4h-9.1c-13.877 0-25.168 11.29-25.168 25.167z"
              />
            </svg>
            <div v-if="userLogoDet.logoDet.agencyname">{{userLogoDet.logoDet.agencyname}}</div>
          </div>
          <div class="email" v-if="userLogoDet.logoDet.email">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background:new 0 0 512 512;"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M467,61H45c-6.927,0-13.412,1.703-19.279,4.51L255,294.789l51.389-49.387c0,0,0.004-0.005,0.005-0.007    c0.001-0.002,0.005-0.004,0.005-0.004L486.286,65.514C480.418,62.705,473.929,61,467,61z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M507.496,86.728L338.213,256.002L507.49,425.279c2.807-5.867,4.51-12.352,4.51-19.279V106    C512,99.077,510.301,92.593,507.496,86.728z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M4.51,86.721C1.703,92.588,0,99.073,0,106v300c0,6.923,1.701,13.409,4.506,19.274L173.789,256L4.51,86.721z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M317.002,277.213l-51.396,49.393c-2.93,2.93-6.768,4.395-10.605,4.395s-7.676-1.465-10.605-4.395L195,277.211    L25.714,446.486C31.582,449.295,38.071,451,45,451h422c6.927,0,13.412-1.703,19.279-4.51L317.002,277.213z"
                  />
                </g>
              </g>
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
            </svg>
            <div v-if="userLogoDet.logoDet.email">{{userLogoDet.logoDet.email}}</div>
    </div>-->
    <!--                            <div class="address">-->
    <!--                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"-->
    <!--                                     version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512"-->
    <!--                                     style="enable-background:new 0 0 512 512;" xml:space="preserve">-->
    <!--<g>-->
    <!--	<g>-->
    <!--		<path d="M256,0C161.896,0,85.333,76.563,85.333,170.667c0,28.25,7.063,56.26,20.49,81.104L246.667,506.5    c1.875,3.396,5.448,5.5,9.333,5.5s7.458-2.104,9.333-5.5l140.896-254.813c13.375-24.76,20.438-52.771,20.438-81.021    C426.667,76.563,350.104,0,256,0z M256,256c-47.052,0-85.333-38.281-85.333-85.333c0-47.052,38.281-85.333,85.333-85.333    s85.333,38.281,85.333,85.333C341.333,217.719,303.052,256,256,256z"/>-->
    <!--	</g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--                                    <g>-->
    <!--</g>-->
    <!--</svg>-->
    <!--                                <div>White Streed, CA, USA</div>-->
    <!--                            </div>-->
    <!-- </div>
    </div>-->
    <!-- userLogoDet&&userLogoDet.b2bCompanyFinancess -->
    <div class="body" v-if="userLogoDet&&userLogoDet.b2bCompanyFinancess">
      <div v-for="(finance, index) in userLogoDet.b2bCompanyFinancess" :key="index" class="content">
        <div class="icon" v-if="finance.symbol">{{finance.symbol}}</div>

        <div class="value">
          <!--               <label class="value" v-if="finance.currecycode">{{finance.currecycode}}</label>-->
          <div class="title" v-if="finance.agenttype==agentType.prepaid && finance.prepaidbalance">
            <div v-c-tooltip.hover="{ content: $t('cLoginInfo.availBalance') , active:false }">
              <div>{{finance.prepaidbalance | formatNumber(finance.currecycode)}}</div>
            </div>
          </div>
          <div
            class="title"
            v-if="finance.agenttype==agentType.postpaid && finance.postpaid_runningamount"
          >
            <div v-c-tooltip.hover="{ content: $t('cLoginInfo.availCreditLimit') , active:false }">
              <div>
                <span v-if="finance.currecycode">{{finance.currecycode}}  </span>
                <span
                  v-if="getPostPaidAmt(finance.postpaidlimit,finance.postpaid_runningamount)!=0"
                >{{getPostPaidAmt(finance.postpaidlimit,finance.postpaid_runningamount)| formatNumber(finance.currecycode)}}</span>
                <span v-else>0</span>
                <!-- {{getPostPaidAmt(finance.postpaidlimit,finance.postpaid_runningamount)!=0 ? 
               (getPostPaidAmt(finance.postpaidlimit,finance.postpaid_runningamount)| formatNumber(finance.currecycode)):
                getPostPaidAmt(finance.postpaidlimit,finance.postpaid_runningamount)}}-->
                <!-- {{getPostPaidAmt(finance.postpaidlimit,finance.postpaid_runningamount)| formatNumber(finance.currecycode)}} -->
              </div>
            </div>
          </div>
          <div class="price text-ellipsis" v-if="finance.pendingbookings">
            <span>{{(finance.pendingbookings=='0' || finance.pendingbookings==0)?'':finance.pendingbookings}}</span>
            {{formatPendingText(finance.pendingbookings)}}
            <!-- <span>{{finance.pendingbookings}}</span>{{formatPendingText(finance.pendingbookings)}} -->
          </div>
          <!-- <div class="progress-b" >
                                    <div class="progress" style="height: 0.4rem;" variant="success">
                                        <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"
                                             class="progress-bar bg-success progress-bar-striped progress-bar-animated"
                                             style="width:70%;"></div>
                                    </div>
          </div>-->
          <div class="progress-b" v-if="finance.agenttype==agentType.prepaid">
            <div class="progress" style="height: 0.4rem;" variant="success">
              <div
                role="progressbar"
                aria-valuemin="0"
                aria-valuemax="100"
                :aria-valuenow="getProgressPercent(finance,true)"
                class="progress-bar bg-success progress-bar-striped progress-bar-animated"
                :style="'width:'+getProgressPercent(finance,true)+'%;'"
              ></div>
            </div>
          </div>
          <div class="progress-b" v-if="finance.agenttype==agentType.postpaid">
            <div class="progress" style="height: 0.4rem;" variant="success">
              <div
                role="progressbar"
                aria-valuemin="0"
                aria-valuemax="100"
                :aria-valuenow="getProgressPercent(finance,false)"
                class="progress-bar bg-success progress-bar-striped progress-bar-animated"
                :style="'width:'+getProgressPercent(finance,false)+'%;'"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="content">
                            <div class="icon">
                                $
                            </div>
                            <div class="value">
                                <div class="title">


                                    50,00,000
                                </div>
                                <div class="price">
                                    <span>12</span>Pending Booking
                                </div>
                                <div class="progress-b">
                                    <div class="progress" style="height: 0.4rem;" variant="success">
                                        <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="46"
                                             class="progress-bar bg-success progress-bar-striped progress-bar-animated"
                                             style="width: 46%;"></div>
                                    </div>

                                </div>
                            </div>
      </div>-->
      <!-- <div class="content">
                            <div class="icon">
                                $
                            </div>
                            <div class="value">
                                <div class="title">


                                    50,00,000
                                </div>
                                <div class="price">
                                    <span>12</span>Pending Booking
                                </div>
                                <div class="progress-b">
                                    <div class="progress" style="height: 0.4rem;" variant="success">
                                        <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="46"
                                             class="progress-bar bg-success progress-bar-striped progress-bar-animated"
                                             style="width: 46%;"></div>
                                    </div>

                                </div>
                            </div>
      </div>-->
    </div>
     <div class="body" v-else>
      <div v-for="(finance) in emptyLoaderContentLen" :key="finance" class="content">
        <div class="icon" ></div>
        <div class="value">
          <div class="title" >
            <div >
              <div>{{''}}</div>
            </div>
          </div>
          <div
            class="title"
          >
            <div >
              <div>
                <span >{{''}}</span>
                <span          
                ></span>
              </div>
            </div>
          </div>
          <div class="price text-ellipsis">
            <span></span>      
          </div>  
          <div class="progress-b" >
            <div class="progress" style="height: 0.4rem;" variant="success">
              <div
                role="progressbar"
                aria-valuemin="0"
                aria-valuemax="100"
                :aria-valuenow="0"
                class="progress-bar bg-success progress-bar-striped progress-bar-animated"
                :style="'width:'+0+'%;'"
              ></div>
            </div>
          </div>
         
        </div>
      </div>
    </div>
    <!-- <div class="foot">
        <div class="d-flex w-100">
          <div class="lan-drop">
            <cLanguagePicker
              v-model="language"
              ctrlName="en_name"
              :isShowCode="true"
              :isMultiple="false"
              :isSearchable="true"
              :url="languageListURL"
              rules="_required"
              :selValue="language"
            />
          </div>
          <div class="logout" @click="onLogout">
            <div class="d-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                style="enable-background:new 0 0 512 512;"
                xml:space="preserve"
              >
                <g>
                  <g>
                    <path
                      d="M255.15,468.625H63.787c-11.737,0-21.262-9.526-21.262-21.262V64.638c0-11.737,9.526-21.262,21.262-21.262H255.15    c11.758,0,21.262-9.504,21.262-21.262S266.908,0.85,255.15,0.85H63.787C28.619,0.85,0,29.47,0,64.638v382.724    c0,35.168,28.619,63.787,63.787,63.787H255.15c11.758,0,21.262-9.504,21.262-21.262    C276.412,478.129,266.908,468.625,255.15,468.625z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="M505.664,240.861L376.388,113.286c-8.335-8.25-21.815-8.143-30.065,0.213s-8.165,21.815,0.213,30.065l92.385,91.173    H191.362c-11.758,0-21.262,9.504-21.262,21.262c0,11.758,9.504,21.263,21.262,21.263h247.559l-92.385,91.173    c-8.377,8.25-8.441,21.709-0.213,30.065c4.167,4.21,9.653,6.336,15.139,6.336c5.401,0,10.801-2.041,14.926-6.124l129.276-127.575    c4.04-3.997,6.336-9.441,6.336-15.139C512,250.302,509.725,244.88,505.664,240.861z"
                    />
                  </g>
                </g>
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
              </svg>
              <div>Logout</div>
            </div>
          </div>
    </div>-->
    <!--<button class="login-btn">Logout</button>-->
    <!-- </div> -->
    <!-- </div> -->

    <!--        <strong>{{ getUserName }}</strong>-->
  </div>
</template>

<script>
//import cLanguagePicker from "./../components/cLanguagePicker";
import { mapActions, mapGetters } from "vuex";
import { handleJWT, getErrorAlertValue, parseNumber } from "./../util/util";
import { PATHNAME, COMPONENT_NAME, APPROVEAGENT } from "../util/constants";
//import apiUserLogoDet from "./../services/apiUserLogoDet";
import Logger from "./../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "./../config/API_DATA";

import { VALIDATE_SUCCESS_RES, getErrorMessage } from "./../util/apiValidate";

import router, { navigate, goBack } from "./../router/index";
import store from "../store";
import apiGetBalanceDetail from "./../services/apiGetBalanceDetail";
import BaseConfiguration from "./../config/base";

export default {
  name: COMPONENT_NAME.C_LOGIN_INFO,

  // components: {
  //   cLanguagePicker
  // },

  data() {
    return {
      // language: [
      //   {
      //     langcode: null,
      //     en_name: null,
      //     native_name: null
      //   }
      // ],
      // languageListURL: SERVICE_URL.LANGUAGE_LIST,
      userLogoDet: {
        //logoDet: null,
        b2bCompanyFinancess: null
      },
      agentType: {
        prepaid: APPROVEAGENT.PREPAID,
        postpaid: APPROVEAGENT.POSTPAID
      },
      emptyLoaderContentLen:1
    };
  },

  methods: {
    ...mapActions("sSysLogin", {
      CLEAR_SYS_LOGIN: "CLEAR_SYS_LOGIN"
    }),
    ...mapActions("sAgtLogin", {
      CLEAR_AGT_LOGIN: "CLEAR_AGT_LOGIN"
    }),
    ...mapActions("sDashBoard", {
      // SET_AGENT_LOGO_DET_REQUEST: "SET_AGENT_LOGO_DET_REQUEST",
      // SET_AGENT_LOGO_DET_RESPONSE: "SET_AGENT_LOGO_DET_RESPONSE",
      SET_AGENT_FINANCE_RESPONSE: "SET_AGENT_FINANCE_RESPONSE"
    }),

    // onLogout() {
    //   try {
    //     // this.CLEAR_AGT_LOGIN();
    //     // this.CLEAR_SYS_LOGIN();
    //     if (store.getters["sSysLogin/GET_ADMIN_SIGNIN_RES"]) {
    //       this.CLEAR_AGT_LOGIN();
    //       this.CLEAR_SYS_LOGIN();
    //       navigate(PATHNAME.SYSTEM_LOGIN);
    //     } else if (store.getters["sAgtLogin/GET_SIGNIN_RES"]) {
    //       this.CLEAR_AGT_LOGIN();
    //       this.CLEAR_SYS_LOGIN();
    //       navigate(PATHNAME.AGENT_LOGIN);
    //     } else {
    //       this.CLEAR_AGT_LOGIN();
    //       this.CLEAR_SYS_LOGIN();
    //       navigate(PATHNAME.AGENT_LOGIN);
    //     }
    //     sessionStorage.removeItem("b2b_admin_mf");
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
    //       "error in navigateToHome",
    //       err.toString(),
    //       "navigateToHome",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    // async getUserLogoDet() {
    //   let returnValue;
    //   try {
    //     let userLogoReq = apiUserLogoDet.buildRequest();
    //     if (userLogoReq != null) {
    //       this.SET_AGENT_LOGO_DET_REQUEST(userLogoReq);
    //       let userLogoRes = await apiUserLogoDet.getResponse(userLogoReq);
    //       if (VALIDATE_SUCCESS_RES(userLogoRes)) {
    //         returnValue = userLogoRes.data.data;
    //         this.SET_AGENT_LOGO_DET_RESPONSE(returnValue);
    //       } else {
    //         let error = getErrorMessage(userLogoRes);
    //         let isJwt = handleJWT(error);
    //         if (!isJwt) {
    //           this.showAlert(getErrorAlertValue(error));
    //         } else {
    //           returnValue = [];
    //         }
    //       }
    //     } else {
    //       throw "invalid request";
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
    //       "error in  getting UserLogo Details",
    //       err.toString(),
    //       " getUserLogoDet()",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return returnValue;
    // },

    formatPendingText(pPendingNum) {
      let retValue;

      try {
        if (BaseConfiguration.isDebug) console.log("formatPendingText");

        if (Number(pPendingNum) == 0) {
          retValue = this.$t("cLoginInfo.noPendingBooking");
        } else if (Number(pPendingNum) == 1) {
          retValue = this.$t("cLoginInfo.pendingBooking");
        } else {
          retValue = this.$t("cLoginInfo.pendingBookings");
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_LOGIN_INFO,
          "error in formatPendingText",
          err.toString(),
          "formatPendingText",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getPostPaidAmt(pPostPaidLimit, pPostPaidRunAmt) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getPostPaidAmt");

        retValue = parseNumber(pPostPaidLimit) - parseNumber(pPostPaidRunAmt);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_LOGIN_INFO,
          "error in getPostPaidAmt",
          err.toString(),
          "getPostPaidAmt",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getBalanceDetail(pB2bid) {
      let returnValue;
      try {
        let balanceReq = apiGetBalanceDetail.buildRequest(pB2bid);
        if (balanceReq) {
          let balanceRes = await apiGetBalanceDetail.getResponse(balanceReq);
          if (VALIDATE_SUCCESS_RES(balanceRes)) {
            returnValue = balanceRes.data.data;
            this.SET_AGENT_FINANCE_RESPONSE(returnValue);
          } else {
            let error = getErrorMessage(balanceRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
          "error in  getBalanceDetail",
          err.toString(),
          " getBalanceDetail()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    getProgressPercent(finance, isPrepaid) {
      try {
        if (BaseConfiguration.isDebug) console.log("getProgressPercent");
        let retValue;
        if (isPrepaid) {
          retValue =
            (parseFloat(finance.prepaidbalance) /
              parseFloat(finance.prepaidbalance)) *
            100;
        } else {
          retValue =
            (parseFloat(finance.postpaid_runningamount) /
              parseFloat(finance.postpaidlimit)) *
            100;
        }
        // console.log(retValue)
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
          "error in getProgressPercent",
          err.toString(),
          "getProgressPercent",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      //return retValue;
    },

    showAlert(val) {
      this.$emit("showAlert", val);
    }
  },

  computed: {
    // getUserName: function() {
    //   let retValue;
    //   try {
    //     if (
    //       this.userLogoDet.logoDet &&
    //       this.userLogoDet.logoDet.firstname &&
    //       this.userLogoDet.logoDet.lastname
    //     ) {
    //       retValue =
    //         this.userLogoDet.logoDet.firstname +
    //         " " +
    //         this.userLogoDet.logoDet.lastname;
    //     } else if (
    //       this.userLogoDet.logoDet &&
    //       this.userLogoDet.logoDet.firstname
    //     ) {
    //       retValue = this.userLogoDet.logoDet.firstname;
    //     } else {
    //       retValue = "";
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
    //       "error in getting user name",
    //       err.toString(),
    //       "getUserName()",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return retValue;
    // },

    ...mapGetters("sDashBoard", {
      userLogoDetail: "GET_AGENT_LOGO_DET_RES",
      GET_AGENT_FINANCE_RES:"GET_AGENT_FINANCE_RES"
    }),
    ...mapGetters("sAgtLogin", { GET_SIGNIN_RES: "GET_SIGNIN_RES" })
  },

  async created() {
    if (BaseConfiguration.isDebug) console.log("created");
    // if (!this.GET_ADMIN_SIGNIN_REQ)
    let logoDetail = null;
    if (this.userLogoDetail) logoDetail = this.userLogoDetail;
    // if(logoDetail)
    // this.userLogoDet.logoDet = logoDetail;
    if(this.GET_AGENT_FINANCE_RES){
      this.emptyLoaderContentLen=this.GET_AGENT_FINANCE_RES.length;
    }
    if (logoDetail && this.GET_SIGNIN_RES){
      let balanceDetails = await this.getBalanceDetail(
        logoDetail.b2bid ? logoDetail.b2bid : null
      );
      if(balanceDetails){
         this.userLogoDet.b2bCompanyFinancess=balanceDetails;
      }else{
        this.userLogoDet.b2bCompanyFinancess=[];
      }
    }else{
      this.userLogoDet.b2bCompanyFinancess=[];
    }
  }
};
</script>
